module.exports = __webpack_public_path__ + "img/DBT.8bcf6732.jpg";